import { render, staticRenderFns } from "./FeeFormDialog.vue?vue&type=template&id=87123a80&scoped=true"
import script from "./FeeFormDialog.vue?vue&type=script&lang=js"
export * from "./FeeFormDialog.vue?vue&type=script&lang=js"
import style0 from "./FeeFormDialog.vue?vue&type=style&index=0&id=87123a80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87123a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87123a80')) {
      api.createRecord('87123a80', component.options)
    } else {
      api.reload('87123a80', component.options)
    }
    module.hot.accept("./FeeFormDialog.vue?vue&type=template&id=87123a80&scoped=true", function () {
      api.rerender('87123a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/feeInfoTab/components/FeeFormDialog.vue"
export default component.exports